export default {
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 0,
      },
      contained: {
        boxShadow: 'none',
      },
    },
  },
  palette: {
    primary: {
      main: '#eac13e',
    },
    secondary: {
      main: '#e08816',
    },
    preOrder: {
      main: '#9200FF',
    },
    price: {
      onSale: '#FF1D1B',
    },
    inventoryStatus: {
      preOrder: '#9200FF',
      high: 'rgb(47,152,38)',
      low: 'rgb(224,137,22)',
      empty: 'rgb(168,166,166)',
    },
    campaign: {
      main: '#007825',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
    },
  },
};
